import { render, staticRenderFns } from "./OnboardingPanel.vue?vue&type=template&id=6c34e070&scoped=true"
import script from "./OnboardingPanel.vue?vue&type=script&lang=js"
export * from "./OnboardingPanel.vue?vue&type=script&lang=js"
import style0 from "./OnboardingPanel.vue?vue&type=style&index=0&id=6c34e070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34e070",
  null
  
)

export default component.exports